import { Controller } from "@hotwired/stimulus";
import ahoy from 'ahoy.js';
import { initFlowbite } from 'flowbite';

export default class extends Controller {
  static targets = [ 'loadingOverlay' ];
  declare readonly loadingOverlayTarget: HTMLElement;

  connect() {
    console.log('app connect');
    ahoy.track('app load', { controller: 'app' });
    initFlowbite();
  }

  turboLoad = () => {
    console.log('turbo load');
    initFlowbite();
  }

  morph = () => {
    console.log('morph');
    initFlowbite();
  }

  // This is a custom event from Flowbite... not sure why their own listener isn't working, but it isn't.
  afterStreamRender = event => {
    console.log('after stream render');
    initFlowbite();
  }

  frameRender = e => {
    console.log('frame render');
    initFlowbite();
  }

  beforeStreamRender = event => {
    if (event.target.firstElementChild instanceof HTMLTemplateElement) {
      const enterAnimationClass = event.target.templateContent.firstElementChild?.dataset?.streamEnterClass;
      if (enterAnimationClass) {
        event.target.templateElement.content.firstElementChild.classList.add(enterAnimationClass);
      }
    }
    if (event.target.getAttribute('action') === 'remove') {
      const elementToRemove = document.getElementById(event.target.getAttribute('target'));
      if (elementToRemove) {
        const streamExitClass = elementToRemove.dataset.streamExitClass;
        if (streamExitClass) {
          event.preventDefault();
          elementToRemove.classList.add(streamExitClass);
          elementToRemove.addEventListener('animationend', function() {
            event.target.performAction();
          })
        }
      }
    }
  }

  showAppLoadingOverlay = e => {
    this.toggleAppLoadingOverlay(true, e.detail.message);
  }

  hideAppLoadingOverlay = e => {
    this.toggleAppLoadingOverlay(false);
  }

  toggleAppLoadingOverlay = (show: boolean, message = null) => {
    if (show) {
      this.loadingOverlayTarget.classList.remove('hidden');
      if (message) this.loadingOverlayTarget.querySelector('.loading-msg').textContent = message;
      else this.loadingOverlayTarget.querySelector('.loading-msg').textContent = 'Loading...';
    }
    else this.loadingOverlayTarget.classList.add('hidden');
  }
}
